var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"uk-button uk-button-secondary"},_vm.$listeners),[(_vm.loading)?_c('span',{attrs:{"uk-spinner":"ratio: 0.7"}}):_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }